var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#777",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.902 4.903l2.532 2.532.012-.133c0-1.33-1.081-2.41-2.411-2.41l-.133.011z",
    transform: "translate(-899 -550) translate(376 224) translate(136 87) translate(1 208) translate(0 21) translate(386 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.023 3.308c2.251 0 4.078 1.825 4.078 4.073 0 .525-.106 1.026-.29 1.486l2.387 2.383C16.43 10.224 17.4 8.896 18 7.38c-1.415-3.575-4.895-6.108-8.977-6.108-1.143 0-2.236.203-3.251.57l1.762 1.755c.46-.179.962-.289 1.489-.289zM.817 1.044L2.679 2.91l.372.373C1.703 4.339.637 5.743 0 7.368c1.413 3.594 4.901 6.14 8.985 6.14 1.266 0 2.475-.246 3.582-.692l.347.348 2.381 2.39 1.042-1.04L1.858 0 .817 1.044zm4.517 4.523l1.262 1.265c-.037.176-.061.352-.061.536 0 1.355 1.098 2.456 2.45 2.456.184 0 .36-.025.531-.062l1.262 1.265c-.543.27-1.147.434-1.793.434-2.254 0-4.084-1.834-4.084-4.093 0-.647.163-1.253.433-1.801z",
    transform: "translate(-899 -550) translate(376 224) translate(136 87) translate(1 208) translate(0 21) translate(386 10)"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/Invisible.eb12571ac73c1d81ace948bb9cec7765.svg";
export { ForwardRef as ReactComponent };